import styled from 'styled-components';

export const StyledQnaAccordionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
